module.exports = __webpack_public_path__ + "static/media/destroyer.d8b7446b.svg";